var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course_areas_list"},_vm._l((_vm.courseAreas),function(courseArea,index){return _c('course-area-list-item',{key:index,class:{
          'mb-2': _vm.separated && !index,
          'my-2': _vm.separated && index,
          'mb-0': _vm.separated && index === _vm.courseAreas.length -1
      },attrs:{"guest":_vm.guest,"separated":_vm.separated,"courseArea":courseArea,"activeCourseId":_vm.activeCourseId},on:{"submit":_vm.submit}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }